// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2eGyL","approved":"Status_approved__35KDZ","rejected":"Status_rejected__1KkiT","expired":"Status_expired__2fjc6","label":"Status_label__1VsqU"};